import { cn } from '@/lib/utils';
import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const plans = [{
  name: 'MegaPack Agenda Llena',
  icon: '📘',
  ideal: 'Lashistas que quieren llenar su agenda 6 días a la semana',
  was: '$54.990 ARS',
  now: '$19.990 ARS',
  featured: false,
  features: ['12 Tomos completos', 'Scripts de WhatsApp listos', 'Protocolo Anti-Cancelaciones', 'Ingeniería de Precios ARG', '5 Bonos estratégicos gratis', 'Garantía 7 días'],
  cta: 'Quiero mi MegaPack'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Precios" className="bg-radial-glow" data-id="element-119" data-mp="25shl2uftn163">
      <div className="mx-auto max-w-5xl px-5 py-20 pb-[23px] pt-[0px]" data-id="element-120" data-mp="20teev6o3uowj">
        

        <div className="mt-10 grid place-items-center" data-id="element-121" data-mp="20vhdgf3bpqcv">
          {plans.map((plan, i) => <motion.div key={plan.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className={cn(`relative flex w-full max-w-md flex-col items-center rounded-3xl border px-7 pb-7 pt-8 text-center ${plan.featured ? 'border-rose bg-ink-2 shadow-[0_20px_60px_-20px_rgba(215,109,138,0.5)]' : 'border-white/10 bg-ink-2'}`)} data-id="element-122" data-mp="3h9hdrr62zi0n" data-mpi={i}>
              {plan.featured && <span className="absolute -top-3 left-1/2 inline-flex -translate-x-1/2 items-center gap-1 rounded-full bg-rose px-4 py-1 text-xs font-extrabold uppercase tracking-wide text-white" data-id="element-123" data-mp="eoz4jei2lzos">
                  <StarIcon className="h-3.5 w-3.5 fill-current" data-id="element-124" data-mp="3i5pg08wf94xv" /> Más completo
                </span>}
              
              <h3 className="font-display text-xl font-black text-white" data-id="element-125" data-mp="3rxlidw5jjh7w">{plan.name}</h3>
              <p className="mt-2 text-sm text-white/60" data-id="element-126" data-mp="2uihbht6thzww">
                <span className="font-semibold text-white/80" data-id="element-127" data-mp="2uhy61byct3zr">Ideal para:</span> {plan.ideal}
              </p>

              <div className="mt-6" data-id="element-128" data-mp="2zfpz49aqiw5j">
                <span className="text-base font-medium text-white/40 line-through" data-id="element-129" data-mp="2rglb1tsdpv9m">{plan.was}</span>
                <div className="font-display text-4xl font-black text-white" data-id="element-130" data-mp="2mi1k1eyxhtae">{plan.now}</div>
                <p className="mt-1 text-xs font-semibold text-rose-soft" data-id="element-131" data-mp="316o8q7ag3xea">Pago único · Acceso de por vida</p>
              </div>

              <ul className="mt-6 w-full flex-1 space-y-3 text-left" data-id="element-132" data-mp="2w7bh798mq25d">
                {plan.features.map(f => <li key={f} className="flex items-center gap-2.5 text-sm text-white/80" data-id="element-133" data-mp="28h7ceyjpfwcs">
                    <CheckIcon className="h-4 w-4 shrink-0 text-rose" strokeWidth={3} data-id="element-134" data-mp="23jfi5xvl7y5f" />
                    {f}
                  </li>)}
              </ul>

              <div className="mt-7 w-full" data-id="element-135" data-mp="2ie3lp6hfgmie">
                <CTAButton size="md" className="w-full" href="https://megapack-agenda-llena.impultienda.ar/checkout" data-id="element-136" data-mp="2dgk8m9wgufs1">
                  {plan.cta}
                </CTAButton>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}